package com.wintermar.inspection.feature.presentation.inspection.answer.modal_state

import com.wintermar.inspection.graphql.type.FindingCategory

data class ModalFindingCategory(
    val show: Boolean = false,
    val questionId: String = "",
    val findingCategory: FindingCategory? = null
)
